import { AllActivitiesTab } from "../AllActivitiesTab/AllActivitiesTab";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import { AllActivitiesWrapper } from "./AllActivitiesStyle";
export const AllActivities = () => {
  return (
    <AllActivitiesWrapper className="mt-3">
      <BreadCrumb
        margin="mt-3"
        num1="واحد CRM"
        num2="گزارشگیری"
        num3="کل فرصت ها و فعالیت ها"
        href1="/dashboard/crm"
        href2="/dashboard/crm/reporting"
      />
      <AllActivitiesTab />
    </AllActivitiesWrapper>
  );
};
